import { Component, ViewChild } from '@angular/core';
import { Platform, NavController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationStorage } from './core/authentication/authentication-storage.service';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('myNav') nav: NavController
  rootPage:any = HomePage;

  constructor(
    platform: Platform, 
    statusBar: StatusBar, 
    splashScreen: SplashScreen, 
    translate: TranslateService,
    public authStorage: AuthenticationStorage) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
      translate.setDefaultLang('it');
      translate.use('it');
    });
  }

  ngOnInit() {
    //[TODO]: capire come fare il redirect
    // this.authStorage.getToken().then(token => {
    //   if(!token) {
    //     this.nav.setRoot('home');
    //   }
    // })
 }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts